import { DirectSalesLineObjective } from 'components/common/types/DirectSalesCampaign.types';

export const isOneTargetSelected = (objective?: DirectSalesLineObjective): boolean => {
  return (
    !!objective &&
    ((!!objective.budget.value && objective.budget.value > 0) ||
      (!!objective.frames.value && objective.frames.value > 0) ||
      (!!objective.impressions.value && objective.impressions.value > 0))
  );
};

export const isOneFilterSelected = (objective?: DirectSalesLineObjective): boolean => {
  return Boolean(
    !!objective &&
      (objective.locations.length ||
        objective.formats.length ||
        objective.tags.length ||
        objective.frameList.listFiles.length ||
        objective.frameList.routeFrameCodes.length ||
        objective.frameList.mapRouteFrameCodes?.length ||
        objective.poi.length),
  );
};

export const isOnlyOneTargetSelected = (objective?: DirectSalesLineObjective): boolean => {
  if (!objective) return false;

  return (
    [objective.budget.value, objective.frames.value, objective.impressions.value].filter((value) => value !== undefined)
      .length === 1
  );
};

export const isOnlyOneFilterSelected = (objective?: DirectSalesLineObjective): boolean => {
  if (!objective) return false;

  return (
    [
      objective.locations,
      objective.formats,
      objective.tags,
      objective.frameList.listFiles,
      objective.frameList.routeFrameCodes,
      objective.frameList.mapRouteFrameCodes,
      objective.poi,
    ].filter((value) => value !== undefined && value.length > 0).length === 1
  );
};
